/**
 * @packageDocumentation
 * @module f1/is
 */

import is_nan from './is_nan';

export interface IsNumber {
  /**
   * Is the value a number
   *
   * @public
   * @function f1.is.number
   * @example
   *
   * ```ts
   * f1.is.number(1) => true
   * f1.is.number(1.0) => true
   * f1.is.number(-1) => true
   * ```
   */
  (value: unknown): value is number;
}

/**
 * @see IsNumber
 */
export default (value: unknown): value is number => {
  return !is_nan(value) && toString.call(value) === '[object Number]';
};
